import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CONSTANTS_DETAILS } from './shared';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth';
import {
  MatProgressSpinnerModule,
  ProgressSpinnerMode,
} from '@angular/material/progress-spinner';
import { SpinnerService } from './services/spinner/spinner.service';
import { AsyncPipe } from '@angular/common';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, MatProgressSpinnerModule, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [AuthService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  public spinnerMode: ProgressSpinnerMode = 'indeterminate';
  constructor(
    private _translate: TranslateService,
    private _authService: AuthService,
    public _spinnerService: SpinnerService,
  ) {
    // Set the default language for the application
    this._translate.setFallbackLang(CONSTANTS_DETAILS.APP_DEFAULT_LANGUAGE);
    this._translate.use(CONSTANTS_DETAILS.APP_DEFAULT_LANGUAGE);
  }

  /**
   * Initializes the application by calling the authInitiator method from AuthService.
   *
   * @memberof AppComponent
   */
  ngOnInit() {
    this._authService.authInitiator();
  }

  /**
   * Cleans up resources by completing the destroying observable in AuthService.
   *
   * @memberof AppComponent
   */
  ngOnDestroy() {
    this._authService._destroying$.next();
    this._authService._destroying$.complete();
  }
}
